import { z } from "zod/v4";

import { BaseIntegrationDtoSchema } from "../../../../dtos/integrations";

export const PluginIntegrationSchema_2023_08_20 = BaseIntegrationDtoSchema.omit(
  { apis: true }
);
export type PluginIntegrationType_2023_08_20 = z.infer<
  typeof PluginIntegrationSchema_2023_08_20
>;
